import { useGetUser } from "@/services/session/useGetUser";
import { SessionContext } from "@/contexts/SessionContext";

export const SessionProvider = ({children,}) => {
  const { data: user, isLoading, isError } = useGetUser();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isError || !user) {
    return <div>Error</div>;
  }

  return (
    <SessionContext.Provider value={{ user }}>
      {children}
    </SessionContext.Provider>
  );
};
